import { Tabs } from 'antd'
import React, { FunctionComponent, useMemo, useRef } from 'react'

import {
  LUSTRATION_TAB_KEYS,
  MonitoringInputType,
} from '../../../common/cuzkMonitorTypes'
import { TabItem, tabsProps } from '../../utils/tabsHelpers'
import { useTabKeyState } from '../../utils/useTabKeyState'
import { CuzkMonitorRcCreateTour } from '../CuzkMonitorRcCreateTour/CuzkMonitorRcCreateTour'
import { IcoInput } from '../IcoInput/IcoInput'
import { NameBirthdateInput } from '../NameBirthdateInput/NameBirthdateInput'
import { RcInput } from '../RcInput/RcInput'

export interface CeeContentCreateProps {
  isMonitoring: boolean
}

export const CeeContentCreate: FunctionComponent<CeeContentCreateProps> = ({
  isMonitoring,
}) => {
  const [activeTabKey, setActiveTabKey] = useTabKeyState<LUSTRATION_TAB_KEYS>(
    LUSTRATION_TAB_KEYS.RC
  )
  const elementRef = {
    rcInput: useRef(null),
    rcSubmit: useRef(null),
    icoInput: useRef(null),
    icoSubmit: useRef(null),
    icoTab: useRef(null),
    nameTab: useRef(null),
  }

  const tabItems = useMemo<TabItem<LUSTRATION_TAB_KEYS>[]>(
    () => [
      {
        key: LUSTRATION_TAB_KEYS.RC,
        label: 'Podle rodného čísla',
        className: 'bg-white p-6',
        children: (
          <RcInput
            type={MonitoringInputType.CeeRc}
            inputRef={elementRef.rcInput}
            buttonRef={elementRef.rcSubmit}
            monitoring={isMonitoring}
          />
        ),
      },
      {
        key: LUSTRATION_TAB_KEYS.ICO,
        label: <div ref={elementRef.icoTab}>Podle IČO</div>,
        className: 'bg-white p-6',
        children: (
          <IcoInput
            inputRef={elementRef.icoInput}
            buttonRef={elementRef.icoSubmit}
            type={MonitoringInputType.CeeIco}
            monitoring={isMonitoring}
          />
        ),
      },
      {
        key: LUSTRATION_TAB_KEYS.NAME,
        label: <span ref={elementRef.nameTab}>Podle jména a narození</span>,
        className: 'bg-white p-6',
        children: (
          <NameBirthdateInput
            inputRef={elementRef.icoInput}
            buttonRef={elementRef.icoSubmit}
            type={MonitoringInputType.CeeName}
            monitoring={isMonitoring}
          />
        ),
      },
    ],
    [
      elementRef.icoInput,
      elementRef.icoSubmit,
      elementRef.icoTab,
      elementRef.nameTab,
      elementRef.rcInput,
      elementRef.rcSubmit,
      isMonitoring,
    ]
  )
  return (
    <Tabs
      {...tabsProps}
      activeKey={activeTabKey}
      items={tabItems}
      onTabClick={setActiveTabKey}
      tabBarExtraContent={
        <CuzkMonitorRcCreateTour
          currentTab={activeTabKey}
          elementRef={elementRef}
        />
      }
    />
  )
}
